import { render, staticRenderFns } from "./y1.vue?vue&type=template&id=231a3985&"
import script from "./y1.vue?vue&type=script&lang=js&"
export * from "./y1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports